<template>
    <div class="pc-topNavBox" @mouseleave="mouseleave()" :class="{ bgFFF: !isTop || $route.path == '/alDetails' || showEj }">
        <div class="topBox">
            <div class="topNav">
                <div class="leftTopNav" v-if="!showEj" @click="toHome">
                    <img src="@/assets/image/common/logo.png" v-if="isTop && $route.path != '/alDetails'" alt="" />
                    <img src="@/assets/image/common/logo2.png" v-else alt="" />
                </div>
                <div class="leftTopNav" v-else @click="toHome">
                    <img src="@/assets/image/common/logo2.png" alt="" />
                </div>
                <div class="rightTopNav">
                    <div class="leftMinRight">
                        <div class="minRight" @mouseenter="mouseenter(v)" :class="{ act: nowPath == v.url && !isTop }" v-wave="{ color: 'blue' }" v-for="(v, i) in navList" :key="i" @click="toPage(v)">
                            {{ v.title }}
                            <span :class="showEj ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" v-show="v.children"></span>
                        </div>
                    </div>
                    <div class="phoneBox">
                        <div class="phoneIcon">
                            <img src="@/assets/image/common/phone.gif" alt="" />
                        </div>
                        <div class="phoneNumber">18224014957</div>
                    </div>
                </div>
            </div>
            <div class="erjiTop" v-show="showEj">
                <div class="erjiBox">
                    <!-- <div class="cpTitle">产品</div> -->
                    <div class="cpBox">
                        <div class="minCp" v-for="(v, i) in navList[1].children" :key="i" @click="toPage(v)">
                            <div class="minTopCp">
                                <img :src="v.img" alt="" />
                                {{ v.title }}
                            </div>
                            <div class="minBottomCp">
                                {{ v.futitle }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showEj: false,
            nowPath: '',
            navList: [
                {
                    title: '首页',
                    url: '/',
                },
                {
                    title: '产品中心',
                    children: [
                        {
                            title: '数字化智慧电商',
                            futitle: '全链条智能化管理，提供便捷、高效的购物体验',
                            img: require('../../assets/image/common/cpIcon1.png'),
                            url: '/ecPlatform',
                        },
                        {
                            title: 'COP协同运营平台',
                            futitle: '管理企业运营数据，提高运营效率',
                            img: require('../../assets/image/common/cpIcon2.png'),
                            url: '/copDetail',
                        },
                        {
                            title: '电子档案平台',
                            futitle: '用于管理和交换首营资料的电子化平台',
                            img: require('../../assets/image/common/cpIcon3.png'),
                            url: '/dzDetail',
                        },
                    ],
                },
                {
                    title: '案例',
                    url: '/alList',
                },
                {
                    title: '关于我们',
                    url: '/aboutUs',
                },
                {
                    title: '联系我们',
                    url: '/contactUs',
                },
            ],
            isTop: true,
        };
    },
    watch: {
        $route: {
            handler(to) {
                this.nowPath = to.path;
            },
            immediate: true,
        },
    },
    methods: {
        toHome() {
            this.$router.push('/');
        },
        toPage(v) {
            this.$router.push(v.url);
        },
        mouseenter(v) {
            if (v.children) {
                this.showEj = true;
            } else {
                this.showEj = false;
            }
        },
        mouseleave() {
            this.showEj = false;
        },
        toPage(row) {
            console.log(row);
            if (row.children) {
            } else {
                this.$router.push(row.url);
            }
        },
        handleScroll() {
            // 处理滚动事件
            // console.log(window.scrollY); // 输出当前滚动位置
            if (window.scrollY != 0) {
                this.isTop = false;
            } else {
                this.isTop = true;
            }
        },
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        // 组件销毁前移除事件监听器
        window.removeEventListener('scroll', this.handleScroll);
    },
};
</script>

<style lang="scss" scoped>
.bgFFF {
    background-color: #fff;
    box-shadow: 0 3px 6px 1px rgba(0, 0, 0, 0.16);

    .minRight {
        color: #333;
    }
}

.colorFFF {
    color: #fff !important;
}

.pc-topNavBox {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;

    .erjiTop {
        width: 100%;
        position: absolute;
        padding-bottom: 15px;
        left: 0;
        top: 60px;
        background-color: #fff;
        z-index: 100;
        display: flex;
        justify-content: center;

        .erjiBox {
            width: 1264px;

            .cpTitle {
                height: 80px;
                display: flex;
                align-items: center;
                font-size: 20px;
                color: #333333;
                font-weight: bold;
            }

            .cpBox {
                margin-top: 20px;
                display: flex;
                gap: 22px;
                .minCp:hover {
                    background-color: #f5f7fa;
                }
                .minCp {
                    width: 385px;
                    height: 85px;
                    border-radius: 8px;
                    box-sizing: border-box;
                    padding: 17px 24px;
                    display: flex;
                    flex-direction: column;
                    gap: 4px;
                    cursor: pointer;

                    .minTopCp {
                        display: flex;
                        align-items: center;
                        height: 24px;
                        font-size: 16px;
                        color: #333333;
                        font-weight: bold;
                        gap: 8px;

                        img {
                            width: 24px;
                            height: 24px;
                            vertical-align: top;
                        }
                    }

                    .minBottomCp {
                        font-size: 14px;
                        color: #9a9a9a;
                        text-indent: 2.2em;
                    }
                }
            }
        }
    }

    .topBox {
        display: flex;
        justify-content: center;
        z-index: 1000;
    }

    .topNav {
        display: flex;
        width: 1200px;
        height: 70px;
        align-items: center;
        justify-content: space-between;
        margin: 0 auto;
        position: relative;

        .leftTopNav {
            width: 319px;
            height: 40px;
            cursor: pointer;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .rightTopNav {
            font-size: 20px;
            color: #fff;
            display: flex;
            height: 100%;
            gap: 30px;
            align-items: center;

            .leftMinRight {
                display: flex;
                height: 100%;
                gap: 30px;
                align-items: center;

                .minRight {
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    gap: 2px;
                    height: 40px;
                    border-radius: 22px;
                    padding: 0 10px;
                    font-size: 16px;
                }
            }

            .phoneBox {
                width: 154px;
                height: 40px;
                background: #1472ff;
                border-radius: 22px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 16px;
                gap: 5px;
                cursor: pointer;

                .phoneIcon {
                    img {
                        width: 24px;
                        height: 24px;
                    }
                }
            }
        }
    }
}
</style>
